import React from "react";
import { StickyNote } from "lucide-react";
import { WebViewPopover } from "../../SubHeader/WebViewPopover";

type RefundClaimNoteType = {
  notes: string;
};

export const RefundClaimNote = ({ notes }: RefundClaimNoteType) => {
  if (!notes) {
    return null;
  }

  return (
    <div className="PaymentNote w-9">
      <WebViewPopover
        side="bottom"
        content={
          <div className="PaymentNote-Container p-[var(--panelPadding)] bg-[var(--footerBackground)] border border-[#757982] rounded-lg">
            <div className="PaymentNote-Header">Notes</div>
            <div className="PaymentNote-Content pt-[var(--panelPadding)]">
              {notes}
            </div>
          </div>
        }
      >
        <button className="PaymentNote-Button">
          <StickyNote className="w-4 h-4" />
        </button>
      </WebViewPopover>
    </div>
  );
};
